import { styled } from "styled-components";

import { colorCSS, fontSizes, shadow, theme } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

export const Detail = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-direction", "column")}
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("width", "100%")}
    ${redundantCssFromKebab("padding", "0 1rem")}
    
    @media (min-width: 992px) {
        ${redundantCssFromKebab("flex-direction", "row")}
        ${redundantCssFromKebab("max-width", "960px")}
    }

    @media (min-width: 1200px) {
        ${redundantCssFromKebab("max-width", "1140px")}
    }

    @media (min-width: 1400px) {
        ${redundantCssFromKebab("max-width", "1320px")}
    }
`;

export const DetailHeading = styled.h3`
    ${redundantCssFromKebab("border-bottom", `1px solid ${colorCSS("N40")}`)}
    ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    ${redundantCssFromKebab("font-family", `${theme.fontFamily.text}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("padding-bottom", "1rem")}
    ${redundantCssFromKebab("width", "100%")}
`;

export const DetailInner = styled.div`
    ${redundantCssFromKebab("transition", "opacity 0.3s ease")}
`;

export const DetailPrimary = styled.div`
    ${redundantCssFromKebab("box-shadow", `${shadow["normal_inset"]}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("padding", "2rem 1rem 4.75rem")}
    ${redundantCssFromKebab("width", "100%")}

    @media (min-width: 992px) {
        ${redundantCssFromKebab("flex", "1 1 auto")}
        ${redundantCssFromKebab("padding", "2rem 0 4.75rem 0")}
        ${redundantCssFromKebab("width", "auto")}
    }
`;

export const DetailPrimaryInner = styled.div`
    ${redundantCssFromKebab("align-items", "start")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-direction", "column")}
    ${redundantCssFromKebab("gap", "1rem")}
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("width", "100%")}
    ${redundantCssFromKebab("padding", "0 1rem")}
    
    @media (min-width: 992px) {
        ${redundantCssFromKebab("margin", "0 2rem 0 auto")}
        ${redundantCssFromKebab("max-width", "640px")}
        ${redundantCssFromKebab("padding", "0 2rem 0 1rem")}
    }

    @media (min-width: 1200px) {
        ${redundantCssFromKebab("max-width", "760px")}
    }
`;

export const DetailPrimaryLinks = styled.nav`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-wrap", "wrap")}
    ${redundantCssFromKebab("margin", "0 -1rem")}
    ${redundantCssFromKebab("gap", "1rem 0")}
    ${redundantCssFromKebab("width", "100%")}
`;

export const DetailPrimaryLink = styled.div`
    ${redundantCssFromKebab("width", "100%")}
    ${redundantCssFromKebab("padding", "0 1rem")}
    
    @media (min-width: 768px) {
        ${redundantCssFromKebab("width", "50%")}
    }

    @media (min-width: 992px) {
        ${redundantCssFromKebab("width", "33.33333%")}
    }
`;

export const DetailSecondary = styled.div`
    ${redundantCssFromKebab("background-color", `${colorCSS("P50", 0.4)}`)}
    ${redundantCssFromKebab("box-shadow", `${shadow["normal_inset"]}`)}
    ${redundantCssFromKebab("padding", "2rem 1rem 4.75rem")}
    ${redundantCssFromKebab("width", "100%")}

    @media (min-width: 992px) {
        ${redundantCssFromKebab("flex", "0 0 280px")}
        ${redundantCssFromKebab("padding", "2rem 0 4.75rem")}
        ${redundantCssFromKebab("width", "280px")}
    }

    @media (min-width: 1200px) {
        ${redundantCssFromKebab("flex", "0 0 332px")}
        ${redundantCssFromKebab("width", "332px")}
    }
`;

export const DetailSecondaryInner = styled.div`
    ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.xxs}`)}
    ${redundantCssFromKebab("margin", "0 auto")}
    ${redundantCssFromKebab("max-width", "100%")}
    ${redundantCssFromKebab("padding", "0 1rem")}
    
    @media (min-width: 992px) {
        ${redundantCssFromKebab("margin", "0 auto 0 2rem")}
        ${redundantCssFromKebab("max-width", "240px")}
        ${redundantCssFromKebab("padding", "0")}
    }

    @media (min-width: 1200px) {
        ${redundantCssFromKebab("max-width", "285px")}
    }
`;

export const DetailSecondaryHeading = styled.h3`
    ${redundantCssFromKebab("border-bottom", `1px solid ${colorCSS("N40")}`)}
    ${redundantCssFromKebab("border-bottom-color", `${colorCSS("P100")}`)}
    ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    ${redundantCssFromKebab("font-family", `${theme.fontFamily.text}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("margin-bottom", "1rem")}
    ${redundantCssFromKebab("padding-bottom", "1rem")}
    ${redundantCssFromKebab("width", "100%")}
`;

export const DetailSecondaryLinks = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-direction", "column")}
    ${redundantCssFromKebab("gap", "1rem")}
    ${redundantCssFromKebab("padding", "1.5rem 0")}

    > * {
        ${redundantCssFromKebab("padding", "0")}
    }
`;

export const DetailSecondaryBanners = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-direction", "column")}
    ${redundantCssFromKebab("gap", "1rem")}

    > * {
        ${redundantCssFromKebab("padding", "0")}
    }
`;
